var _g, _path, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLfi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 276,
    height: 121,
    viewBox: "0 0 276 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13_257",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 133,
    height: 121
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13_257)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.181 77.1622L129.059 77.1013C127.751 76.4193 126.199 77.1013 125.71 78.5018C124.757 81.2541 122.802 83.7142 119.832 85.2608L72.0509 110.227C68.507 112.09 64.2665 112.09 60.7104 110.227L12.9291 85.2608C9.95955 83.7142 8.0043 81.2541 7.05112 78.5018C6.57452 77.1135 5.01033 76.4193 3.70275 77.1013L3.58055 77.1622C-1.19759 79.6588 -1.19759 86.4665 3.58055 88.9631L63.2645 120.152C65.2075 121.163 67.5294 121.163 69.4724 120.152L129.169 88.9631C133.947 86.4665 133.947 79.6588 129.169 77.1622H129.181Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.181 54.7906L129.059 54.7297C127.751 54.0478 126.199 54.7297 125.71 56.1303C124.757 58.8826 122.802 61.3426 119.832 62.8893L72.0509 87.8549C68.507 89.7182 64.2666 89.7182 60.7104 87.8549L12.9169 62.8893C9.94732 61.3426 7.99208 58.8826 7.03889 56.1303C6.5623 54.7419 4.9981 54.0478 3.69053 54.7297L3.56833 54.7906C-1.20981 57.2872 -1.20981 64.0949 3.56833 66.5915L63.2523 97.7803C65.1953 98.7911 67.5172 98.7911 69.4602 97.7803L129.156 66.5915C133.934 64.0949 133.934 57.2872 129.156 54.7906H129.181Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.58052 43.7449L7.77208 45.9248L14.4566 49.42L27.3734 56.1547L35.5855 60.4536L64.7065 75.6523C65.7574 76.2003 67.0161 76.2003 68.067 75.6523L77.2323 70.8662C82.0104 68.3696 82.0104 61.5619 77.2323 59.0653L57.7287 48.872L49.5166 44.5852L47.8669 43.7205C43.272 41.3092 43.101 34.9156 47.3536 32.2242C47.5125 32.1145 47.6958 32.0171 47.8669 31.9197L75.3503 17.5614L82.4259 13.8713C85.0044 12.5195 85.0044 8.84165 82.4259 7.50203L69.4846 0.767382C67.5416 -0.243424 65.2197 -0.243424 63.2767 0.767382L3.58052 31.944C-1.19762 34.4284 -1.19762 41.2483 3.58052 43.7449Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0917 31.9439C71.6232 33.2348 70.4256 35.6826 70.5233 38.094C70.6089 40.3226 71.7942 42.5025 74.055 43.7204C74.0672 43.7204 74.0794 43.7326 74.0917 43.7447L98.52 56.5077C98.52 56.5077 98.5445 56.5077 98.5567 56.5199C100.475 57.5307 102.773 57.5307 104.703 56.5199C104.703 56.5199 104.728 56.5199 104.74 56.5077L105.388 56.1667L118.305 49.4077L124.989 45.9247L129.181 43.7447C129.181 43.7447 129.205 43.7326 129.217 43.7204C133.959 41.2116 133.947 34.4283 129.181 31.9439L104.74 19.1688C104.655 19.1322 104.581 19.0835 104.484 19.047C104.447 19.0226 104.41 19.0104 104.374 18.9861C102.663 18.0849 100.61 18.0849 98.8989 18.9861C98.8989 18.9861 98.8133 19.0226 98.7889 19.047C98.7033 19.0835 98.6178 19.1322 98.5322 19.1688L88.4627 24.4298L79.4808 29.1307L74.1039 31.9439H74.0917Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13_257)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M135.209 -3.05347H-1.83524V123.349H135.209V-3.05347Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49,
    d: "M54.206 100.649C87.4881 100.649 114.469 73.7198 114.469 40.5009C114.469 7.28192 87.4881 -19.6473 54.206 -19.6473C20.9238 -19.6473 -6.05667 7.28192 -6.05667 40.5009C-6.05667 73.7198 20.9238 100.649 54.206 100.649Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_13_257)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.264 100.504V18.2367H173.766V89.5852H204.306V100.504H161.264Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.775 100.504V18.2367H257.738V28.9157H225.277V54.4594H253.655V65.2518H225.277V100.504H212.775V100.504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.286 28.9283V18.1359H275.587V28.9283H264.286ZM264.286 100.504V37.4261H275.587V100.504H264.286Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_257"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 132.761,
    height: 120.907,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_13_257"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 114.323,
    height: 82.3679,
    fill: "white",
    transform: "translate(161.264 18.1359)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLfi);
export default __webpack_public_path__ + "static/media/LFI.c9567485a220c5395deafa3e74bdfa2c.svg";
export { ForwardRef as ReactComponent };